// Text entry. Input is the pill (Figma "Input": the coach composer, search);
// Field is the labelled form box (Figma "Field": Default / Focus / Error).
import * as React from 'react';
import { cn } from '../../lib/utils';

export const Input = React.forwardRef(function Input({ className, ...props }, ref) {
  return (
    <input ref={ref}
      className={cn('h-12 w-full rounded-full border border-border-default bg-bg-surface px-4 type-body text-text-primary',
        'placeholder:text-text-tertiary focus:border-accent-default focus:outline-none', className)}
      {...props} />
  );
});

export const Field = React.forwardRef(function Field({ label, hint, error, id, className, inputClassName, ...props }, ref) {
  const auto = React.useId();
  const inputId = id || auto;
  const noteId = `${inputId}-note`;
  const note = error || hint;
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label htmlFor={inputId} className="type-label text-text-secondary">{label}</label>
      <input ref={ref} id={inputId} aria-invalid={error ? true : undefined} aria-describedby={note ? noteId : undefined}
        className={cn('min-h-[50px] w-full rounded-chip border bg-bg-canvas px-3.5 type-body text-text-primary placeholder:text-text-tertiary',
          'focus:outline-none focus:ring-0',
          error ? 'border-[1.5px] border-status-danger' : 'border-border-default focus:border-[1.5px] focus:border-accent-default',
          inputClassName)}
        {...props} />
      {note ? (
        <p id={noteId} role={error ? 'alert' : undefined}
          className={cn('m-0 type-caption', error ? 'text-status-danger' : 'text-text-tertiary')}>{note}</p>
      ) : null}
    </div>
  );
});
